export default class TimezonesService {
  constructor($http, host, notify) {
    this.$http = $http;
    this.host = host;
    this.notify = notify;
  }

  getTimezones() {
    return this.$http({
      method: 'GET',
      url: this.host + '/api/timezones'
    }).then(
      (resp) => { return resp.data.timezones; },
      (resp) => {
        this.notify.error({
          message: "Ha ocurrido un error en la comunicación con nuestros servidores, intente nuevamente."
        });
        return resp.data;
      }
    );
  }
}

 TimezonesService.$inject = ['$http', 'host', 'Notification'];



// WEBPACK FOOTER //
// ./src/app/services/timezones.service.js